import { render, staticRenderFns } from "./CreditRiskRating.vue?vue&type=template&id=b74b0d62&scoped=true&"
import script from "./CreditRiskRating.vue?vue&type=script&lang=js&"
export * from "./CreditRiskRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74b0d62",
  null
  
)

export default component.exports